<template >
  <div class="fac">
    <div class="fac-top clear" :style="isEdit ? '' : 'border-radius: 10px;'">
      <div class="fac-top-city clear">
        <div class="l" v-if="queryParma">
          {{ fromLabel }}
          <i class="fa fac-arrow fa-arrowEdit"></i>
          {{ toLabel }}
        </div>
        <div @click="edit" class="fac-top-edit blueBtn l">Edit Search</div>
      </div>
      <ul v-show="!isEdit" class="clear marTop10">
        <li class="l">Commodity:{{ CargoNameEn }}</li>
        <!-- <li class="l marL10">
          <label class="text2 total">
            <span>Shipment total: </span>
            <em>{{ partInfo.total?partInfo.total.sumUnit:queryParma.quantity }} Unit</em>
            <em>{{ InterceptUnit(partInfo.total?partInfo.total.sumKG:queryParma.weight, 3) }} KG</em>
            <em>{{ InterceptUnit(partInfo.total?partInfo.total.sumCBM:queryParma.volume, 4) }} CBM</em>
          </label>
        </li> -->
      </ul>
    </div>
    <transition name="el-zoom-in-top">
      <div v-show="isEdit" class="fac-bot clear">
        <div class="fac-bot-city">
          <strong class="label-air font12" style="margin-left: 60px">From：</strong>
          <by-select style="margin-left: 10px" id="airPort" v-model="airPortObj" :select-data="airPort" @filterOpt="filterOpt" class="select320" @focus="foucsData1" @blur="blurData1" setPlaceholder="Origin Airport" required>
            <by-option v-for="item in airPort" :key="item.AirportCode3" :item="item" icon="fa fa-Airfeiji" :label="
                item.AirportCode3.length > 3
                  ? item.AirportNameEn
                  : item.AirportCode3 + '(' + item.AirportNameEn + ')'
              " :value="item.AirportCode3">
            </by-option>
          </by-select>
          <strong class="label-air font12" style="margin-left: 65px">To：</strong>
          <by-select id="endAirPort" v-model="endAirPortObj" :select-data="endAirPort" @filterOpt="filterEndOpt" setPlaceholder="Destination Airport" @focus="foucsData2" class="select320 isRlabel" required>
            <by-option v-for="item in endAirPort" :key="item.AirportCode3" :item="item" icon="fa fa-Airfeiji" :rLabel="item.CountryNameEn" :label="item.AirportCode3 + '(' + item.AirportNameEn + ')'" :value="item.AirportCode3">
            </by-option>
          </by-select>
        </div>
        <div class="fac-cargo">
          <div class="marBot20">
            <span class="fontB font12" style="margin-left: 33px">Shipment：</span>
            <label class="text marL10">
              <span class="hint marR5">
                <el-radio v-model="queryType" :label="1">
                  <span class="font12">Calculate by boxes/pallets</span>
                </el-radio>
                <div class="floTipBox" style="right: 0px; top: 25px">
                  <i></i>
                  <p>
                    Input cargo weight, length/width/height to ensure the
                    accuracy of total freight.You can click "add another unit"
                    to add different sizes of packaging info., the system will
                    automatically calculate the total load.
                  </p>
                </div>
              </span>
              <el-radio v-model="queryType" :label="2" style="margin-left: 55px">
                <span class="font12">Calculate by total shipment</span>
              </el-radio>
            </label>
          </div>
          <calculateByBoxes v-model="totalByBoxes" v-show="queryType === 1" /><!--@sumbitQuery='sumbitQuery'-->
          <calculateByTotal v-model="totalByTotal" v-show="queryType === 2" :weightDensity="weightDensity" :volumeDensity="volumeDensity" @sendByTotal="sendByTotal" /><!--@sumbitQuery='sumbitQuery'-->
        </div>
        <typesOfGoods v-model="goodsObj" :list="cargoList" :isSHRshow="isSHRshow" />
        <div style="line-height: 30px">
          <span class="dataTip colRed font12">
            <i class="fa fa-tips2 font14 colRed" style="margin-top: -3px"></i>
            Rejected goods: all contain liquid, powder, imitation brand, famous
            brand, paste and other items.
          </span>
        </div>
        <div>
          <div @click="sumbitQuery" class="blueBtn enquiry">Enquiry</div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import typesOfGoods from "./typesOfGoods";
import BySelect from "@/components/Reception/public/bySelect.vue";
import ByOption from "@/components/Reception/public/byOption.vue";
import { post, fetch, Del, put } from "@/ask/axios";
import calculateByBoxes from "./calculateByBoxes";
import calculateByTotal from "./calculateByTotal";
import { getCookie } from "@/ask/cookiejs";
import { getCustomer } from "@/utils/getCustomer";
import EventBus from "@/ask/eventBus";
export default {
  components: {
    typesOfGoods,
    BySelect,
    ByOption,
    calculateByBoxes,
    calculateByTotal,
  },
  props: {
    queryParma: Object,
    cargoData: Array,
    cargoList: Array,
    weightDensity: Number,
    volumeDensity: Number,
  },
  data() {
    return {
      titNames: "Air Freight",
      titUrls: ",",

      airPort: [],
      airPortObj: {},
      bfAirPort: [], // 备份airPort 用于筛选数据

      endAirPort: [],
      endAirPortObj: {},
      bfEndAirPort: [], // endAirPort 用于筛选数据

      isEdit: false, //控制开关动画
      wcaCountryKey: "", //wca 国家key

      // 查询条件
      queryType: 2,
      totalByBoxes: {},
      totalByTotal: {},
      goodsObj: {}, //包含是否有货物种类id和上海化工报告字段

      // 筛选
      arrivalType: [],
      istThWorkDays: [],

      startReqTips: false,
      destReqTips: false,

      airTip1: false,
      airTip2: false,
      partInfo: [],
      customerOwnerType: 2,
      CustomerID: 0,
      airline: [],

      ShipmentTotal: null,
    };
  },
  created() {
    //获取用户信息
    let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
    if (U_info) {
      this.customerOwnerType = U_info.CustomerOwnerType;
      this.CustomerID = U_info.CustomerID;
    }
    this.getStartAir();
    this.getEndAir();
  },
  watch: {},
  mounted() {
    if (getCookie("X-BY-EnTOKEN")) {
      getCustomer()
        .then((Customer) => {
          this.wcaCountryKey = Customer.WCAQueryCountryKey;
        })
        .catch((error) => { });
    }
  },
  computed: {
    CargoNameEn() {
      var cargoEn = [];
      this.queryParma.cargoTypeIDList.forEach((item) => {
        this.cargoData.forEach((ele) => {
          if (item == ele.Id) {
            cargoEn.push(ele.AttrVal_ContentEn);
          }
        });
      });
      return cargoEn.join(",");
    },
    isSHRshow() {
      let show = false;
      if (this.goodsObj.cargoIDs && this.airPortObj.value) {
        if (
          (this.goodsObj.cargoIDs.includes(sysCfg.air.Cargo.builtInBatID) ||
            this.goodsObj.cargoIDs.includes(sysCfg.air.Cargo.packedBatID)) &&
          (this.airPortObj.value === "SHA" ||
            this.airPortObj.value === "PVG" ||
            this.airPortObj.value.length > 3)
        ) {
          show = true;
        }
      }
      return show;
    },
    fromLabel() {
      if (this.queryParma && this.bfAirPort.length) {
        if (this.queryParma.startAirportCodeList == null) {
          return "All airports";
        } else if (this.queryParma.startAirportCodeList.length > 1) {
          return "All airports";
        } else {
          let label = this.queryParma.startAirportCodeList.join();
          let label1 = "";
          this.bfAirPort.forEach((item) => {
            if (item.AirportCode3 === label) {
              label1 = item.AirportNameEn;
            }
          });
          return label + "," + label1;
        }
      }
    },
    toLabel() {
      if (this.queryParma && this.bfEndAirPort.length) {
        let label = this.queryParma.destAirportCodeList.join();
        let label1 = "";
        this.bfEndAirPort.forEach((item) => {
          if (item.AirportCode3 === label) {
            label1 = item.AirportNameEn;
          }
        });
        return label + "," + label1;
      }
    },
  },
  watch: {
    fromLabel(val) {
      //console.log(val);
      if (val != "All airports") {
        let airCode = val.split(",")[0];
        this.getStartAir(airCode);
      } else {
        this.getStartAir("All airports");
      }
    },
  },
  mounted() {
    EventBus.$on("aMsg", (msg) => {
      this.partInfo = msg;
    });
  },
  methods: {
    sendByTotal(val) {
      // console.log("====this.ShipmentTotal",val);
      this.$emit("ShipmentTotal", val);
      //this.ShipmentTotal=val;
    },
    getStartAir(code1 = this.$route.query.code1) {
      let url = this.$api04 + "/Air/api/Airline/StartAirportQuery";
      // let code1 = this.$route.query.code1;
      fetch(url).then((res) => {
        // de
        if (res.Results) {
          if (res.Results.length > 0) {
            this.airPort = res.Results;
            var codeArr = [];
            this.airPort.forEach((ele) => {
              codeArr.push(ele.AirportCode3);
            });
            let code = codeArr.join();
            this.airPort.unshift({
              AirportCode3: code,
              AirportNameEn: "All airports",
            });

            this.bfAirPort = JSON.parse(JSON.stringify(this.airPort));

            let airItem;

            if (code1 != "All airports") {
              airItem = this.bfAirPort.filter((item) => {
                return item.AirportCode3 == code1;
              })[0];
            } else {
              airItem = this.bfAirPort[0];
            }

            let airPortObj = {};
            if (code1.length > 3) {
              airPortObj = {
                item: airItem,
                label: "All airports",
                value: airItem.AirportCode3,
              };
            } else {
              airPortObj = {
                item: airItem,
                label: airItem.AirportCode3 + "(" + airItem.AirportNameEn + ")",
                value: airItem.AirportCode3,
              };
            }
            this.airPortObj = airPortObj;
          }
        }
      });
    },
    getEndAir() {
      let url = this.$api04 + "/Basics/api/Airport/QueryPort";
      post(url).then((res) => {
        if (res.Results) {
          this.endAirPort = res.Results;
          if (this.wcaCountryKey) {
            this.endAirPort = this.endAirPort.filter((item) => {
              if (
                String(item.Country_Key).toUpperCase() == this.wcaCountryKey
              ) {
                return item;
              }
            });
          }
          //console.log(this.endAirPort);
          this.bfEndAirPort = JSON.parse(JSON.stringify(this.endAirPort));
          let airItem = this.bfEndAirPort.filter((item) => {
            return item.AirportCode3 == this.$route.query.code2;
          })[0];
          let endAirPortObj = {
            item: airItem,
            label: airItem.AirportCode3 + "(" + airItem.AirportNameEn + ")",
            value: airItem.AirportCode3,
          };
          this.endAirPortObj = endAirPortObj;
        }
      });
    },

    filterOpt(val) {
      if (val) {
        this.airPort = this.bfAirPort.filter((item) => {
          let showTxt = `${item.AirportCode3}(${item.AirportNameEn})`;
          return showTxt.toUpperCase().indexOf(val.toUpperCase()) != -1;
        });
      } else {
        this.airPort = this.bfAirPort;
      }
    },
    foucsData1() {
      this.airPort = this.bfAirPort;
    },
    blurData1() {
      if (this.isEmptyVal(this.airPortObj)) {
        this.airTip1 = true;
      } else {
        this.airTip1 = false;
      }
    },
    blurData2() {
      if (this.isEmptyVal(this.endAirPortObj)) {
        this.airTip2 = true;
      } else {
        this.airTip2 = false;
      }
    },
    foucsData2() {
      this.endAirPort = this.bfEndAirPort;
    },
    filterEndOpt(val) {
      if (val) {
        this.endAirPort = this.bfEndAirPort.filter((item) => {
          let showTxt = `${item.AirportCode3}(${item.AirportNameEn})`;
          return showTxt.toUpperCase().indexOf(val.toUpperCase()) != -1;
        });
      } else {
        this.endAirPort = this.bfEndAirPort;
      }
    },

    edit() {
      this.isEdit = !this.isEdit;
    },
    checkInfo() {
      //console.log("===airline",this.airline);
      let check = true;
      if (!this.airPortObj.value || !this.endAirPortObj.value) {
        check = false;
      }
      if (this.queryType == 1) {
        this.totalByBoxes.radCargo.forEach((item) => {
          if (
            this.myIsNaN(item.length) ||
            this.myIsNaN(item.width) ||
            this.myIsNaN(item.height) ||
            this.myIsNaN(item.quanlity) ||
            this.myIsNaN(item.unit) ||
            this.myIsNaN(item.weight)
          ) {
            check = false;
          }
        });
      } else {
        let totalInfo = this.totalByTotal.totalInfo;
        if (
          this.myIsNaN(totalInfo.unit) ||
          this.myIsNaN(totalInfo.unitValue) ||
          this.myIsNaN(totalInfo.volume) ||
          this.myIsNaN(totalInfo.weight)
        ) {
          check = false;
        }
      }
      if (!this.goodsObj.cargoIDs.length) {
        check = false;
      }
      if (this.isSHRshow) {
        if (this.goodsObj.isSHReport === "") {
          check = false;
        }
      }
      return check;
    },
    myIsNaN(value) {
      return value == "";
    },
    sumbitQuery() {
      let check = this.checkInfo();
      if (!check) {
        return false;
      }
      //当选择货物信息时，只要包含了托盘，木箱和其他，就只显示托盘的价格
      //包材类型PackagingType 1：纸箱，2：托盘
      let PackagingType = 1;
      let queryType = this.queryType;
      if (queryType === 1) {
        let newCarg = this.totalByBoxes.radCargo.some((e) => {
          return e.unit != 1
        })
        if (newCarg) {
          PackagingType = 2;
        }
        this.$emit("childFn", this.totalByBoxes);
      } else {
        if (this.totalByTotal.totalInfo.unitValue != 'CTNS') {
          PackagingType = 2;
        }
        this.$emit("childFn", this.totalByTotal);
      }

      let { sumCBM, sumCFT, sumKG, sumLB, sumUnit } =
        queryType === 1 ? this.totalByBoxes.total : this.totalByTotal.total;
      let { volumeUnit } =
        queryType === 1
          ? this.totalByBoxes.volumeUnit
          : this.totalByTotal.volumeUnit;
      let radCargo =
        queryType === 1
          ? this.totalByBoxes.radCargo.map((item) => {
            if (volumeUnit === 0) {
              return {
                Long: Number(item.length),
                Wide: Number(item.width),
                Height: Number(item.height),
                Quanlity: Number(item.quanlity),
                VolumeUnit: Number(item.unit),
                Weight: Number(item.weight),
              };
            } else {
              return {
                Long: item.length * 2.54,
                Wide: item.width * 2.54,
                Height: item.height * 2.54,
                Quanlity: Number(item.quanlity),
                VolumeUnit: Number(item.unit),
                Weight: item.weight * 0.4535924,
              };
            }
          })
          : [];
      let { cargoIDs, isSHReport } = this.goodsObj;
      let startCode3 = this.airPortObj.value.split(",");
      let lengthCode = startCode3.length;
      let endCode3 = this.endAirPortObj.value.split(",");
      // console.log("===startCode3",startCode3.length);
      // let queryParma = {
      //   OrderServiceType: 3, //机场到机场 默认是3
      //   QueryGoodType: this.queryType,
      //   TotalQuanlity: sumUnit,
      //   TotalWeight: sumKG,
      //   TotalCBM: sumCBM,
      //   UnitLabel: unitLabel,
      //   QueryGoodUnit :volumeUnit,
      //   GoodInfos: radCargo,
      //   CargoTypeIDs: cargoIDs,
      //   IsSHReport: isSHReport,
      //   IsQueryDisableAirChannel: false,
      //   LstStartAirPortCode3: startCode3,
      //   LstDestAirPortCode3: endCode3,
      //   ArrivalType: this.arrivalType,
      //   lstThWorkDays: this.istThWorkDays,
      //   OrderBy: "comprehensive",
      //   Skip: 0,
      //   Take: 5,
      //   //埋点数据查询要用
      //   statrText:this.airPortObj.label,
      //   endText:this.endAirPortObj.label,
      //   endCountry:this.endAirPortObj.item.CountryNameEn,
      // };
      let isGoods = true;
      if (cargoIDs == sysCfg.air.Cargo.generalCargoID) {
        isGoods = false;
      }

      let cargoArr = [];
      cargoIDs.forEach((item) => {
        this.cargoData.forEach((ele) => {
          if (item == ele.Id) {
            cargoArr.push(ele.AttrVal_Content);
          }
        });
      });
      // this.checkPrice(
      //   "国际空运",
      //   lengthCode > 1 ? "所有机场" : this.airPortObj.value,
      //   "",
      //   this.endAirPortObj.value,
      //   this.endAirPortObj.item.CountryNameCh,
      //   "",
      //   sumKG,
      //   sumCBM,
      //   sumUnit,
      //   isGoods,
      //   cargoArr,
      //   false,
      //   "机场到机场"
      // );
      let queryParma = {
        skip: 0,
        take: 9999,
        orderBy: "price",
        orderByDesc: "aa",
        customerID: this.CustomerID,
        customerOwnerType: this.customerOwnerType,
        // orderServiceType: 3, //机场到机场 默认是3
        goodsReadyTime: new Date().Format("yyyy-MM-dd"),
        // channelKey: '',//渠道Key
        // channelOwnerType: 0,
        // startCityKey: '',//起运城市Key
        startAirportCodeList: lengthCode > 1 ? null : startCode3,
        destAirportCodeList: endCode3,
        arrivalType: this.arrivalType != 0 ? this.arrivalType : null,
        //airCompanyKeyList: [],//航空公司Key
        weight: sumKG,
        volume: sumCBM,
        quantity: sumUnit,
        cargoTypeIDList: cargoIDs,
        PackagingType: PackagingType,
        "platformType": "web",
        "isLogin": false,
        "entrance": "Air Freight"
      };
      this.$emit("queryMethod", queryParma);
      //EventBus.$emit("checkEnquiry",queryParma);
      this.isEdit = !this.isEdit;

      // this.checkPrice('Air Freight',this.airPortObj.label,'',this.endAirPortObj.label,this.endAirPortObj.item.CountryNameEn,'',
      // Number(sumKG),Number(sumCBM),Number(sumUnit),isGoods,cargoArr,false,'Terminal to Terminal')
    },
    isEmptyVal(val) {
      if (
        JSON.stringify(val) == "{}" ||
        !val ||
        val === undefined ||
        val === null
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style >
.select320 {
  width: 195px;
}
.select320 .clearInput {
  width: 190px !important;
  background: white !important;
}
.select320 .s-ulBox {
  width: 195px !important;
}
.select320 .NoData {
  width: 190px !important;
}
</style>
<style scoped>
@import "../../../../assets/css/userCenterCss.css";
/* frontAirCheck === fac */
.label-air {
  line-height: 30px;
  color: black;
}
.fac {
  border-radius: 10px;
}
.fac-top {
  padding: 10px 30px 15px 30px;
  border: 1px solid #eeeeee;
  background: #fff;
  border-radius: 10px 10px 0px 0;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.12);
}
.fac-bot {
  background: #fafafa;
  padding: 20px 35px;
  border-radius: 0 0 10px 10px;
  border-top: 1px solid #eeeeee;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.12);
}

.blueBtn {
  background: #004fb1;
  color: white;
  border-radius: 15px;
  text-align: center;
}
.fac-top-city {
  line-height: 30px;
  font-size: 14px;
  color: black;
  font-weight: 600;
}
.fac-top-edit {
  width: 110px;
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
}
.fac-arrow {
  font-size: 12px;
  margin: -2px 5px 0;
  color: #004fb1;
}
.fac-startCity {
  width: 320px;
}
.enquiry {
  margin: 10px auto 0;
  width: 120px;
  height: 30px;
  line-height: 30px;
}

.el-zoom-in-top-enter-active,
.el-zoom-in-top-leave-active {
  opacity: 1;
  transform: scaleY(1);
  transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
    opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
  transform-origin: center top;
}
.el-zoom-in-top-enter,
.el-zoom-in-top-leave-active {
  opacity: 0;
  transform: scaleY(0);
}
.fac-cargo {
  padding: 15px 0;
}
.fontB {
  font-weight: bold;
  color: black;
}
.min-em {
  min-width: 60px;
  display: inline-block;
}
.total {
  text-align: right;
  font-size: 12px;
}
.blueBtn {
  padding: 0 !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/reception/air/query/query.vue